<template>
  <div v-if="$auth.user?.is_impersonated && $auth.user?.impersonator?.id">
    <v-btn
      class="d-none d-md-block"
      color="primary"
      height="44"
      v-tooltip:bottom="'Stop impersonating ' + $auth.user.name_abbr"
      style="border-radius: 10px"
      @click="stopImpersonating"
    >
      <v-icon
        class="mr-3"
        :size="24"
      >
        undo
      </v-icon>
      <ProfileImage
        :user="$auth.user.impersonator"
        size="32"
        bordered
        border-width="1"
      />
      <span class="ml-3 d-none d-md-block">
        {{ $auth.user.impersonator.name_abbr }}
      </span>
    </v-btn>

    <v-badge
      class="d-md-none mx-4 cursor-pointer"
      color="primary"
      offset-y="-2"
      location="bottom left"
      rounded="circle"
      v-tooltip:bottom="'Stop impersonating ' + $auth.user.name_abbr"
      @click="stopImpersonating"
    >
      <ProfileImage
        :user="$auth.user.impersonator"
        size="32"
        bordered
        class="elevation-4"
      />
      <template #badge>
        <v-icon
          size="15"
          class="rounded-circle"
        >
          undo
        </v-icon>
      </template>
    </v-badge>
  </div>
</template>
<script lang="ts">
import ProfileImage from "@/components/ProfileImage.vue"

export default {
  name: 'StopImpersonatingButton',
  components: {ProfileImage},
  props: {

  },
  methods: {
    async stopImpersonating() {
      if (!(await this.$confirm(
        'Stop Impersonating',
        `Are you sure you want to stop impersonating ${this.$auth.user?.name_abbr}?`,
        {
          showCancel: true,
        }
      ))) return
      await this.$auth.stopImpersonating()

      location.reload()
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
